module.exports = __webpack_public_path__ + "img/loader.ba007522.svg";